/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { HorizontalNavQueueInnerQuery } from '@jira/navigation-apps__horizontal-nav-jsm-queue/src/ui/__generated__/HorizontalNavQueueInnerQuery.graphql';
import parameters from '@jira/navigation-apps__horizontal-nav-jsm-queue/src/ui/__generated__/HorizontalNavQueueInnerQuery$parameters';
import type { PreloadedQuery } from 'react-relay';
import { getProjectKeyId } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import { JiraServicedeskQueueAri } from '@atlassian/ari/jira-servicedesk/queue';
import type { RouteResource } from '@atlassian/react-resource-router';
import { withGiraAggAnonSsrFix } from '../../../common/utils.tsx';

const NAVIGATION_ITEMS_PAGE_SIZE = 75;

export const getQuery: Parameters<
	typeof createRelayResource<HorizontalNavQueueInnerQuery>
>[0]['getQuery'] = (
	// oxlint-disable-next-line typescript/no-explicit-any
	{ match, query }: { match: any; query: any },
	{ tenantContext: { activationId, cloudId } },
) => {
	const queueId = match.params.queueId;
	let { projectKey, projectId } = getProjectKeyId(match, query);
	projectKey = projectKey ?? '';
	projectId = projectId ?? '';
	const projectIdOrKey = projectId || projectKey;

	const queueAri = queueId
		? JiraServicedeskQueueAri.create({
				siteId: cloudId,
				queueId: queueId || '',
				activationId,
			}).toString()
		: '';

	const containerNavigationInput = queueAri
		? { scopeId: queueAri }
		: { projectKeyQuery: { cloudId, projectKey } };

	return {
		options: {
			fetchPolicy: 'store-and-network' as const,
		},
		parameters,
		variables: {
			cloudId,
			projectIdOrKey,
			containerNavigationInput,
			first: NAVIGATION_ITEMS_PAGE_SIZE,
		},
	};
};

export const horizontalNavQueueResource: RouteResource<
	PreloadedQuery<HorizontalNavQueueInnerQuery, Record<string, unknown>>
> = withGiraAggAnonSsrFix(
	createRelayResource<HorizontalNavQueueInnerQuery>({
		type: 'HORIZONTAL_NAVIGATION_QUEUE_QUERY',
		getQuery,
	}),
);
